import { render, staticRenderFns } from "./View20.vue?vue&type=template&id=665e13ab&scoped=true&"
import script from "./View20.vue?vue&type=script&lang=js&"
export * from "./View20.vue?vue&type=script&lang=js&"
import style0 from "./View20.vue?vue&type=style&index=0&id=665e13ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e13ab",
  null
  
)

export default component.exports